import React from 'react';

import { ContentTypeDropdown } from './content-type-dropdown';

import { messages } from '../messages';
import { CustomsField } from '../customs-field';

export const CustomsContentType = () => {
  return (
    <CustomsField label={messages.contentsLabel} recommended>
      <ContentTypeDropdown />
    </CustomsField>
  );
};
